"use strict";

window.$ = window.jQuery = $;

import "./single-product.js";
import "./product-pricepicker.js";
import "./product-datepicker.js";
import "./ga-tracker.js";
import "./bing-tracker.js";
// LV-9168: Old GA ecommerce tracking disabled - replaced by ga4-ecommerce.js
// import "./product-datalayer.js";
